import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'react-toastify/dist/ReactToastify.css';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Optimized query client configuration to reduce API calls
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Set longer stale time to prevent unnecessary refetches
      staleTime: 1000 * 60 * 5, // 5 minutes
      // Set cache time to keep data in cache longer
      gcTime: 1000 * 60 * 10, // 10 minutes (renamed from cacheTime)
      // Disable automatic refetching to reduce load
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      refetchOnMount: true,
      // Reduce retry attempts for failed requests
      retry: 1,
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
    },
    mutations: {
      // Reduce retry for mutations
      retry: 1,
    },
  },
});

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
